import React from 'react';
import { Divider, VStack } from '@wegroup/design-system';
import AddInsuranceModalInsuranceFormGeneral from './AddInsuranceModalInsuranceFormGeneral';
import AddInsuranceModalInsuranceFormDocuments from './AddInsuranceModalInsuranceFormDocuments';
import { InsurancePolicyType } from '../../../../../../../types/AdvisoryReport';
import AddInsuranceModalCoverageExtraFields from '../coverage-form/AddInsuranceModalCoverageExtraFields';
import AddInsuranceModalInsuranceFormPremiumFields from './AddInsuranceModalInsuranceFormPremiumFields';
import AddInsuranceModalInsuranceExtractionAlert from '@advisory-report/src/features/creation-flow/components/insurance-policies/shared/modal/insurance-form/AddInsuranceModalInsuranceExtractionAlert';
import useFeatureFlags from '../../../../../../../../../app/src/hooks/useFeatureFlags';

interface Props {
  type: InsurancePolicyType;
  hideAIBanner?: boolean;
}

const AddInsuranceModalInsuranceForm: React.FC<Props> = ({
  type,
  hideAIBanner,
}) => {
  const { isDocumentExtractionEnabled } = useFeatureFlags();

  return (
    <VStack
      align="stretch"
      spacing="4"
      divider={<Divider borderColor="gray.50" />}
    >
      {!hideAIBanner && isDocumentExtractionEnabled && (
        <AddInsuranceModalInsuranceExtractionAlert type={type} />
      )}
      <AddInsuranceModalInsuranceFormGeneral type={type} />
      <AddInsuranceModalInsuranceFormPremiumFields showAllFields />
      <AddInsuranceModalCoverageExtraFields />
      <AddInsuranceModalInsuranceFormDocuments />
    </VStack>
  );
};

export default AddInsuranceModalInsuranceForm;
